import { servicePath } from "constants/defaultValues";
import { put, takeEvery } from "redux-saga/effects";
import { request } from "services/requests.services";

function* getChatBotCallRequest(action) {
const { page = 1, searchKeyword = "", status = "" } = action.state;
  try {
    const data = yield request("GET", `${servicePath}/chatbot/getQueryCallRequest?page=${page}&searchKeyword=${searchKeyword}&status=${status}`, {
      user_id: action.state.user_id
    });
    yield put({ type: "GET_CHATBOT_DATA_SUCCESS", data: data?.data, loading: false, message: data.message });
  } catch (error) {
    yield put({
      type: "GET_CHATBOT_DATA_FAILED",
      message: "Failed to get data !"
    });
  }
}

function* addComments(action) {
  try {
    const data = yield request("POST", `${servicePath}/chatbot/addCommentsInQuery`, {
      ...action.state
    });
    yield put({ type: "CHATBOT_ADD_COMMENT_SUCCESS", data: data.data, message: data.message });
  } catch (error) {
    yield put({
      type: "CHATBOT_ADD_COMMENT_FAILED",
      message: "Failed to get data !"
    });
  }
}
function* getCommentHistory(action) {
  try {
    const data = yield request("POST", `${servicePath}/chatbot/getQueryCommentsHistory`, {
      ...action.state
    });
    yield put({ type: "CHATBOT_GET_COMMENT_HISTORY_SUCCESS", data: data.data, message: data.message });
  } catch (error) {
    yield put({ type: "CHATBOT_GET_COMMENT_HISTORY_FAILED", message: "Failed to get data !" });
  }
}

function* chatBotCloseQuery(action) {
  const { activeUser, searchKeyword, currentPage, status , _id} = action.state;
  try {
    const data = yield request("PUT", `${servicePath}/chatbot/closeQuery`, {
      _id
    });
    if (data.success === false) {
      yield put({
        type: "CHATBOT_CLOSE_QUERY_FAILED",
        message: data.message
      });
      return;
    }

    yield put({
      type: "CHATBOT_CLOSE_QUERY_SUCCESS",
      data: data.data,
      loading: false,
      message: data.message
    });

    yield put({
      type: "GET_CHATBOT_DATA",
      state: { user_id: activeUser?.data?.user_id, searchKeyword, page: currentPage, status }
    });

  } catch (error) {
    yield put({
      type: "CHATBOT_CLOSE_QUERY_FAILED",
      message: "Failed to close query!"
    });
  }
}
export default function* chatBotSaga() {
  yield takeEvery("GET_CHATBOT_DATA", getChatBotCallRequest);
  yield takeEvery("CHATBOT_ADD_COMMENT", addComments);
  yield takeEvery("CHATBOT_GET_COMMENT_HISTORY", getCommentHistory);
  yield takeEvery("CHATBOT_CLOSE_QUERY", chatBotCloseQuery);
}
